import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Customize Select Component
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

// Toast message on upload
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

// Import Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Import Scss
import "@/scss/main.scss";

// Import Font Awesome
import "@fortawesome/fontawesome-free/js/all.min.js";

// Infinite Scroll

// Editor
// Editor
import 'tinymce'

/* Required TinyMCE components */
import 'tinymce/icons/default/icons.min.js';
import 'tinymce/themes/silver/theme.min.js';
import 'tinymce/models/dom/model.min.js';

/* Import a skin (can be a custom skin instead of the default) */
import 'tinymce/skins/ui/oxide/skin.js';

/* Import plugins */
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';

/* content UI CSS is required */
import 'tinymce/skins/ui/oxide/content.js';

/* The default content CSS can be changed or replaced with appropriate CSS for the editor content. */
import 'tinymce/skins/content/default/content.js';


// Vue Init
let app = createApp(App);
app.use(Toast);

app.component("v-select", vSelect);

import JsonExcel from "vue-json-excel3";

app.component("DownloadExcel", JsonExcel);

// setup algolia
import InstantSearch from "vue-instantsearch/vue3/es";

import mixins from "./mixins";

app.use(InstantSearch);
app.mixin(mixins);

app.use(store).use(router).mount("#app");

export { app };
